import apiClient from './apiClient'
import { API_CONFIG } from './config'
import { mockDependencies, delay } from './mockData'

// Fetch dependencies by database name
const getDependencies = async (databaseName) => {
  if (API_CONFIG.useMockData) {
    console.log('📦 Using mock data: dependencies for', databaseName)
    return delay(mockDependencies[1])
  }
  
  const response = await apiClient.get(`/Dependencies/database/${databaseName}`)
  return response.data
}

// Legacy method for backward compatibility
const getDependenciesByAppId = async (applicationId) => {
  if (API_CONFIG.useMockData) {
    console.log('📦 Using mock data: dependencies', applicationId)
    return delay(mockDependencies[applicationId] || mockDependencies[1])
  }
  
  const response = await apiClient.get(`/Dependencies/application/${applicationId}`)
  return response.data
}

const dependenciesService = {
  getDependencies,
  getDependenciesByAppId,
}

export default dependenciesService
